module.exports = __webpack_public_path__ + "chefy-goals.png?64b8ecf6bbe8fddc421e235b5245fae9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-goals.png
// module id = 33
// module chunks = 0